import React from 'react';
import LandPageTypes from '../LandPageTypes';
import AdminPageTypes from '../AdminPageTypes';
import Datatable from '../controls/Datatable.jsx';
import SelectEvent from '../controls/SelectEvent.jsx';
import DatatablesCallbacks from '../../datatables/DatatablesCallbacks';
import '../../../resources/css/relatorio.css';
import _ from 'lodash';
import {setDatetimePicker} from "../controls/DatetimePicker";

class VendasPorProdutos extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const app = this.props.app;

        if (app.landPage !== LandPageTypes.ADMIN || app.adminPage !== AdminPageTypes.RELATORIO_VENDAS_POR_PRODUTOS)
            return null;

        const token = this.props.token;
        const eventId = this.props.participants.selectedEvent ? this.props.participants.selectedEvent.id : null;
        const relatorio = this.props.relatorioVendasPorProdutos;
        const categories = _.map(relatorio.categories, (c) => c);
        const domClassName = 'report-vendas-por-produtos-datatables';

        categories.unshift({name: 'Todas', id: null});

        const datatablesColumns = [
            { data: "product.name", title: "Item", render: $.datatable.renders.text() },
            { data: "qtd", title: "Quantidade", render: $.datatable.renders.number(".") },
            { data: "total", title: "Total (R$)", render: $.datatable.renders.money(".", ",", 2) },
            { data: "percent", title: "Percentual (%)", render: $.datatable.renders.number(".", ",", 2) },
        ];

        let urlBase = '/api/reports/vendas/por_produtos';
        let inicioDate = null;
        let fimDate = null;
        let categoryId = null;
        let callbacks = new DatatablesCallbacks({
            token: token,
            selectUrl: `${urlBase}?${$.param(_.pickBy({eventId}, _.identity))}`,
        });

        function updateUrl(dt) {
            const query = {
                '_': (new Date()).getTime(),
                inicio: inicioDate,
                fim: fimDate,
                categoryId,
                eventId,
            };

            callbacks._selectUrl = `${urlBase}?${$.param(_.pickBy(query, _.identity))}`;
            dt.ajax.reload();
        }

        const buttons = [
            {
                extend: 'csv',
                text: 'download',
                fieldSeparator: ';',
                filename: 'VendasDosNucleos',
            },
            {
                extend: 'collection',
                text: 'Categorias: ' + categories[0].name,
                className: 'categorias-button-group',
                buttons: _.map(categories, function (category) {
                    return {
                        text: category.name,
                        action: function (e, dt) {
                            categoryId = category.id;
                            $('.' + domClassName + ' .categorias-button-group').text('Categorias: ' + category.name);
                            updateUrl(dt);
                        }
                    }
                }),
                autoClose: true,
            },
            {
                text: 'Início: não especificado',
                className: 'inicio-datetime-picker',
            },
            {
                text: 'Fim: não especificado',
                className: 'fim-datetime-picker',
            },
        ];

        const postCreation = function (dt) {
            let inicio = "." + domClassName + " .inicio-datetime-picker";
            let fim = "." + domClassName + " .fim-datetime-picker";

            setDatetimePicker(inicio, (ev) => {
                $(inicio).text('Início: ' + ev.text);
                inicioDate = ev.query;
                updateUrl(dt);
            });

            setDatetimePicker(fim, (ev) => {
                $(fim).text('Fim: ' + ev.text);
                fimDate = ev.query;
                updateUrl(dt);
            });
        };

        const dom = '<"row"<"col-sm-12"B>>' +
            '<"row"<"col-sm-12"rt>>' +
            '<"row"<"col-sm-6"i><"col-sm-6"p>>';

        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <h2>Relatório de Vendas por Produtos</h2>
                    </div>
                </div>

                <SelectEvent {...this.props}/>

                <Datatable DomClassName={domClassName}
                           dom={dom}
                           title={null}
                           subTitle={null}
                           responsive={true}
                           pageLength={100}
                           buttons={buttons}
                           editorCreateVisible={false}
                           editorEditVisible={false}
                           editorRemoveVisible={false}
                           datatablesSelect={callbacks.select.bind(callbacks)}
                           datatablesColumns={datatablesColumns}
                           postCreation={postCreation}
                />
            </div>
        );
    }
}

export default VendasPorProdutos;



// WEBPACK FOOTER //
// src/views/pages/RelatorioVendasPorProdutos.jsx